import { FC } from "react";
import { JourneyType } from "src/Modules/Flights/constants";
import JourneyPaths from "../JourneyPaths/JourneyPaths";
import { getValues } from "src/utility/tree";
import { DERIVED_JOURNEY_TREE } from "../../constants";
import JourneyCardTags from "../JourneyCardTags/JourneyCardTags";

const JourneyCardMainSection: FC<{journeyData:JourneyType}> = ({journeyData}) => {
  const { airline, isRefundable, segments, imgUrl, isLcc} = getValues(journeyData, DERIVED_JOURNEY_TREE);

  return (
    <div className="flex flex-col gap-4 md:px-5">
      <div className="flex items-center justify-between">
        <div className="flex flex-1 items-center justify-start gap-3">
          <img src={imgUrl} className="max-w-10! md:max-w-14! aspect-square w-full rounded-sm!"  />
          <div className="text-12 md:text-xl text-font-default font-medium">{airline}</div>
        </div>
        <div className="flex gap-1 font-inter font-medium flex-col md:flex-row">
          <JourneyCardTags tags={{isRefundable,isLcc}}/>
        </div>
      </div>
      <div className="flex-1 px-3">
        <JourneyPaths segments={segments} />
      </div>
    </div>
  );
};

export default JourneyCardMainSection;
